export class ScopeRestrictionDTO{
    public id!: string;
    public name!: string;
}